import React, { useContext, useEffect, useState } from "react";
import { Card, Label, Input, Badge } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    Col,
    Row,
    OverlineTitle,
    Sidebar,
    UserAvatar,
} from "../../../components/Component";

import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { urlTenantID, currentTime, findUpper, formDataUsername, getFileTypeFromDataURL, monthNames, timeStamp, todaysDate } from "../../../utils/Utils";
import { UserContext } from "../user-manage/UserContext";
import { notes } from "../user-manage/UserData";
import TenantTab from "./TenantTab";
import TenantHeading from "./TenantHeading";
import { SetTenantIdUp } from "../../../utils/Utils"
import Api from "../../../Api";
import Swal from "sweetalert2";
import zIndex from "@mui/material/styles/zIndex";
import { cloneDeep } from "lodash";

const TenantConfiguration = ({ match }) => {
    const location = useLocation();
    const { contextData } = useContext(UserContext);
    const [data] = contextData;
    const [defaultFiles, setDefaultFiles] = useState({
        logo: null,
        favicon: null,
        loginImage: null,
    });
    const [val, setVal] = useState({
        APPLICATION_HEADER: "",
        APPLICATION_FOOTER: ""
    });
    const [logos, setlogos] = useState({
        APPLICATION_LOGO: null,
        APPLICATION_ICON: null,
        APPLICATION_LOGIN_IMAGES: null,
    });

    const [logoUrl, setLogoUrl] = useState({
        APPLICATION_LOGO: null,
        APPLICATION_ICON: null,
        APPLICATION_LOGIN_IMAGES: null,
    });

    const [prefer, setPrefer] = useState({
        APPLICATION_HEADER: "",
        APPLICATION_FOOTER: ""
    });

    const [preferLogo, setPreferLogo] = useState({
        APPLICATION_LOGO: "",
        APPLICATION_ICON: "",
        APPLICATION_LOGIN_IMAGES: "",
    })

    const [error, setError] = useState({
        APPLICATION_LOGO: "",
        APPLICATION_ICON: "",
        APPLICATION_LOGIN_IMAGES: "",
        APPLICATION_HEADER: "",
        APPLICATION_FOOTER: "",
    })

    const getSmsSettings = async () => {
        let data = JSON?.stringify([
            { tenantId: urlTenantID(), keyStr: "APPLICATION_HEADER", },
            { tenantId: urlTenantID(), keyStr: "APPLICATION_FOOTER", },
            { tenantId: urlTenantID(), keyStr: "APPLICATION_ICON", },
            { tenantId: urlTenantID(), keyStr: "APPLICATION_LOGIN_IMAGES", },
            { tenantId: urlTenantID(), keyStr: "APPLICATION_LOGO", },
        ])
        try {
            let response = await Api?.getSmtpSettings(data);
            let res = response?.data?.data;
            let logoUrls = cloneDeep(logoUrl);
            if (res !== null) {
                let datas = {};
                let prefers = {};
                res.forEach(curr => {
                    datas[curr.keyStr] = curr.valueStr || "";
                    prefers[curr.keyStr] = curr.tenantPrefId;
                    if (curr.keyStr === "APPLICATION_ICON") {
                        logoUrls.APPLICATION_ICON = curr?.valueStr
                    } else if (curr.keyStr === "APPLICATION_LOGIN_IMAGES") {
                        logoUrls.APPLICATION_LOGIN_IMAGES = curr?.valueStr
                    } else if (curr.keyStr === "APPLICATION_LOGO") {
                        logoUrls.APPLICATION_LOGO = curr?.valueStr
                    }
                });
                setVal(datas);
                setPrefer(prefers);
                setLogoUrl(logoUrls)
            }
        } catch (error) {
            Swal?.fire({
                icon: "error",
                title: "Something Went Wrong",
            })
        }

        try {
            let response = await Api?.getlogos(`?Keys=APPLICATION_LOGO&Keys=APPLICATION_ICON&Keys=APPLICATION_LOGIN_IMAGE&TenantID=${urlTenantID()}`);
            let prefers = cloneDeep(preferLogo);
            response?.data?.data?.forEach(item => {
                setlogos(prevLogos => ({
                    ...prevLogos,
                    // [item.keyStr]: item.valueStr,
                    [item.keyStr]: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8mcdA_uoJahxn3PQ-IC9WROV-GF2wuTl2FQ&s",
                }));
                prefers[item?.keyStr] = item?.tenantPrefId
            });
            setPreferLogo(prefers)
        } catch (error) {
            Swal?.fire({
                icon: "error",
                title: "Something Went Wrong",
            })
        }
    }

    const areAllFieldsEmpty = (err) => {
        return Object.values(err).every(value => value === "");
    };

    useEffect(() => {
        let url = +(location?.pathname)?.split("/")?.[4];
        if(typeof url === "number"){
            sessionStorage?.setItem("tempTenantId", url);
        }
        getSmsSettings();
    }, [])

    const areAllEmpty = () => {
        return Object.values(prefer).every(value => value === "");
    };

    const areAllEmptys = () => {
        return Object.values(preferLogo).every(value => value === "");
    };

    // grabs the id of the url and loads the corresponding data
    useEffect(() => {
        const id = match.params.id;
        SetTenantIdUp(id || "");
    }, [match.params.id, data]);

    const handleGeneralSubmit = async (eve) => {
        eve.preventDefault();
        let errors = {
            ...error, // Spread the current error state
            APPLICATION_HEADER: val.APPLICATION_HEADER ? "" : "This Field is Required.",
            APPLICATION_FOOTER: val.APPLICATION_FOOTER ? "" : "This Field is Required.",
            APPLICATION_ICON: logoUrl.APPLICATION_ICON !== null ? "" : "This Field is Required.",
            APPLICATION_LOGIN_IMAGES: logoUrl.APPLICATION_LOGIN_IMAGES !== null ? "" : "This Field is Required.",
            APPLICATION_LOGO: logoUrl.APPLICATION_LOGO !== null ? "" : "This Field is Required."
        };

        if (areAllFieldsEmpty(errors)) {
            let data = JSON?.stringify([
                {
                    tenantId: urlTenantID(),
                    keyStr: "APPLICATION_HEADER",
                    valueStr: val?.APPLICATION_HEADER,
                    createdOn: timeStamp(),
                    createdBy: formDataUsername(),
                    updatedOn: timeStamp(),
                    updatedBy: timeStamp(),
                },
                {
                    tenantId: urlTenantID(),
                    keyStr: "APPLICATION_FOOTER",
                    valueStr: val?.APPLICATION_FOOTER,
                    createdOn: timeStamp(),
                    createdBy: formDataUsername(),
                    updatedOn: timeStamp(),
                    updatedBy: timeStamp(),
                },
            ]);
            let response = "";
            try {
                response = await Api?.insertSmtpSettings(data);

            } catch (error) {
                Swal?.fire({
                    icon: "error",
                    title: "Something Went Wrong"
                });
            }
            let datas = [];
            let responses = ""
            if (logoUrl?.APPLICATION_LOGO?.split(",")[1]) {
                datas?.push({
                    "tenantId": urlTenantID(),
                    "keyStr": "APPLICATION_LOGO",
                    "tenantLogo": logoUrl?.APPLICATION_LOGO?.split(",")[1],
                    "docFileType": (getFileTypeFromDataURL(logoUrl?.APPLICATION_LOGO)),
                    "createdBy": formDataUsername(),
                    "updatedBy": formDataUsername(),

                })
            }
            if (logoUrl?.APPLICATION_ICON?.split(",")[1]) {
                datas?.push({
                    "tenantId": urlTenantID(),
                    "keyStr": "APPLICATION_ICON",
                    "tenantLogo": logoUrl?.APPLICATION_ICON?.split(",")[1],
                    "docFileType": getFileTypeFromDataURL(logoUrl?.APPLICATION_ICON),
                    "createdBy": formDataUsername(),
                    "updatedBy": formDataUsername(),

                })
            }
            if (logoUrl?.APPLICATION_LOGIN_IMAGES?.split(",")[1]) {
                datas?.push({
                    "tenantId": urlTenantID(),
                    "keyStr": "APPLICATION_LOGIN_IMAGES",
                    "tenantLogo": logoUrl?.APPLICATION_LOGIN_IMAGES?.split(",")[1],
                    "docFileType": getFileTypeFromDataURL(logoUrl?.APPLICATION_LOGIN_IMAGES),
                    "createdBy": formDataUsername(),
                    "updatedBy": formDataUsername(),
                })
            }
            if (datas?.length > 0) {
                datas = JSON?.stringify(datas);
                try {
                    responses = await Api?.updateEditLogos(datas);
                    Swal?.fire({
                        icon: responses?.data?.statusCode === 200 ? "success" : "error",
                        title: responses?.data?.statusCode === 200 ? "Tenant Configuration Updated Successfully" : "Something Went Wrong"
                    });
                    getSmsSettings();
                } catch (error) {
                    // console.log(error);
                }
            }
            if (response?.data?.statusCode === 200 || responses?.data?.statusCode === 200) {
                if (response?.data?.statusCode === 200) {
                    Swal?.fire({
                        icon: "success",
                        title: "Tenant Preferences Updated Successfully"
                    })
                }
            }


        }

        setError(errors);


    }

    const handleChange = (eve) => {
        const { name, value } = eve?.target;
        setVal({ ...val, [name]: value });
    }

    const handleImageRemove = (eve, name) => {
        setlogos({
            ...logos, [name]: null
        })
    }

    const handleSetLogo = (eve) => {
        const { name, } = eve?.target;
        const file = eve.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setDefaultFiles({ ...defaultFiles, [name]: reader.result });
                setLogoUrl({ ...logoUrl, [name]: reader.result });
            };
            reader.readAsDataURL(file);
        }
    }

    return (
        <React.Fragment>
            <Head title="User Details - Regular"></Head>
            {/* {user && ( */}
            <Content>
                <TenantHeading heading={"Tenant Configuration"} />
                <TenantTab match={match} />
                <Block>
                    <Card className="card-bordered">
                        <div className="card-aside-wrap" id="user-detail-block">
                            <div className="card-content">
                                <div className="card-inner">
                                    <Block>
                                        <h4 className="mb-3">General</h4>
                                        <form onSubmit={eve => handleGeneralSubmit(eve)}>
                                            <Row className="mb-3 responsive_tab">
                                                <Col md="6">
                                                    <div className="form-group">
                                                        <Label className="form-label" htmlFor="first-name">
                                                            Title
                                                        </Label>
                                                        <div className="form-control-wrap">
                                                            <input className="form-control bg-blue-dim" type="text" name="APPLICATION_HEADER"
                                                                value={val?.APPLICATION_HEADER} onChange={eve => handleChange(eve)} />
                                                            {error?.APPLICATION_HEADER !== "" && <span className="invalid">{error?.APPLICATION_HEADER}</span>}
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md="6">
                                                    <div className="form-group">
                                                        <Label className="form-label" htmlFor="middle-name">
                                                            Footer
                                                        </Label>
                                                        <div className="form-control-wrap">
                                                            <input className="form-control bg-blue-dim" type="text" name="APPLICATION_FOOTER"
                                                                value={val?.APPLICATION_FOOTER} onChange={eve => handleChange(eve)} />
                                                            {error?.APPLICATION_FOOTER !== "" && <span className="invalid">{error?.APPLICATION_FOOTER}</span>}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className="mb-3 responsive_tab">
                                                <Col md="4">
                                                    <div className="form-group">
                                                        <Label className="form-label">Logo </Label>
                                                        <div className="form-control-wrap">
                                                            <div className="form-file position-relative">
                                                                <Input
                                                                    type="file"
                                                                    id="customFile"
                                                                    name="APPLICATION_LOGO"
                                                                    onChange={(e) => handleSetLogo(e)}
                                                                    accept="image/*"
                                                                    className="bg-blue-dim"
                                                                />
                                                                {(logoUrl?.APPLICATION_LOGO !== "" && logoUrl?.APPLICATION_LOGO !== null) && <div className="">
                                                                    <img src={logoUrl?.APPLICATION_LOGO} alt="" className="h-100 position-absolute w-100 top-0 end-0 imgLogoFormSubmit" />
                                                                    <Icon name={"delete"} className="position-absolute top-0 end-0 imgLogoFormSubmit text-danger fs-5 cursor_pointer"
                                                                        onClick={eve => handleImageRemove(eve, "APPLICATION_LOGO")} style={{ zIndex: "1" }} />
                                                                </div>}
                                                                {error?.APPLICATION_LOGO !== "" && <span className="invalid">{error?.APPLICATION_LOGO}</span>}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md="4">
                                                    <div className="form-group">
                                                        <Label className="form-label">Favicon</Label>
                                                        <div className="form-control-wrap">
                                                            <div className="form-file position-relative">
                                                                <Input
                                                                    type="file"
                                                                    id="customFile"
                                                                    name="APPLICATION_ICON"
                                                                    onChange={(e) => handleSetLogo(e)}
                                                                    accept="image/*"
                                                                    className="bg-blue-dim"
                                                                />
                                                                {(logoUrl?.APPLICATION_ICON !== "" && logoUrl?.APPLICATION_ICON !== null) && <div className="">
                                                                    <img src={logoUrl?.APPLICATION_ICON} alt="" className="h-100 position-absolute w-100 top-0 end-0 imgLogoFormSubmit" />
                                                                    <Icon name={"delete"} className="position-absolute top-0 end-0 imgLogoFormSubmit text-danger fs-5 cursor_pointer"
                                                                        onClick={eve => handleImageRemove(eve, "APPLICATION_ICON")} style={{ zIndex: "1" }} />
                                                                </div>}
                                                                {error?.APPLICATION_ICON !== "" && <span className="invalid">{error?.APPLICATION_ICON}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md="4">
                                                    <div className="form-group">
                                                        <Label className="form-label">Login Image </Label>
                                                        <div className="form-control-wrap">
                                                            <div className="form-file position-relative">
                                                                <Input
                                                                    type="file"
                                                                    id="customFile"
                                                                    name="APPLICATION_LOGIN_IMAGES"
                                                                    onChange={(e) => handleSetLogo(e)}
                                                                    accept="image/*"
                                                                    className="bg-blue-dim"
                                                                />
                                                                {(logoUrl?.APPLICATION_LOGIN_IMAGES !== "" && logoUrl?.APPLICATION_LOGIN_IMAGES !== null) && <div className="">
                                                                    <img src={logoUrl?.APPLICATION_LOGIN_IMAGES} alt="" className="h-100 position-absolute w-100 top-0 end-0 imgLogoFormSubmit" />
                                                                    <Icon name={"delete"} className="position-absolute top-0 end-0 imgLogoFormSubmit text-danger fs-5 cursor_pointer"
                                                                        onClick={eve => handleImageRemove(eve, "APPLICATION_LOGIN_IMAGES")} style={{ zIndex: "1" }} />
                                                                </div>}
                                                                {error?.APPLICATION_LOGIN_IMAGES !== "" && <span className="invalid">{error?.APPLICATION_LOGIN_IMAGES}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="justify-end">
                                                <Button color="primary" className="me-3" type="submit" >Save</Button>
                                            </div>
                                        </form>
                                    </Block>
                                </div>
                            </div>
                        </div>
                    </Card>
                </Block>
            </Content>
            {/* )} */}
        </React.Fragment>
    );
};
export default TenantConfiguration;
